import {XHTTP} from '@/shared/xhttp';
import {EssenceAchatService} from "@/xhttp/EssenceAchatService";
import {Achat} from "@/models/Achat";
import {LongueursAchat} from "@/models/LongueursAchat";
import {BoisType} from "@/models/BoisType";
import {Livraison} from "@/models/Livraison";

@XHTTP(EssenceAchatService, '/essenceAchats')
export class EssenceAchat {

	private _id: number;
	private _boisType: BoisType;
	private _longueursAchat: LongueursAchat;
	private _volumeAchat: number;
	private _unite: string;
	private _volumeRestant: number;
	private _prixStere: number;
	private _prixVente: number;
	private _tritu: boolean;
	private _finCoupe: string;
	private _paye: string;
	private _achat: Achat;
	private _livraisons: Livraison[];
	private _delta: number;
	private _createdAt: Date;

	/////////////
	// Getters //
	/////////////

	public get id(): number {
		return this._id;
	}
	
	public get boisType(): BoisType {
		return this._boisType;
	}

	public get longueursAchat(): LongueursAchat {
		return this._longueursAchat;
	}

	public get volumeAchat(): number {
		return this._volumeAchat;
	}

	public get unite(): string {
		return this._unite;
	}

	public get volumeRestant(): number {
		return this._volumeRestant;
	}

	public get prixStere(): number {
		return this._prixStere;
	}

	public get prixVente(): number {
		return this._prixVente;
	}

	public get achat(): Achat {
		return this._achat;
	}

	public get finCoupe(): string {
		return this._finCoupe;
	}

	public get tritu(): boolean {
		return this._tritu;
	}

	public get paye(): string {
		return this._paye;
	}

	public get delta(): number {
		return this._delta;
	}

	public get createdAt(): Date {
		return this._createdAt;
	}

	/////////////
	// Setters //
	/////////////

	public set boisType(value: BoisType) {
		this._boisType = value;
	}

	public set longueursAchat(value: LongueursAchat) {
		this._longueursAchat = value;
	}

	public set volumeAchat(value: number) {
		this._volumeAchat = value;
	}

	public set unite(value: string) {
		this._unite = value;
	}

	public set volumeRestant(value: number) {
		this._volumeRestant = value;
	}

	public set prixStere(value: number) {
		this._prixStere = value;
	}

	public set prixVente(value: number) {
		this._prixVente = value;
	}

	public set achat(value: Achat) {
		this._achat = value;
	}

	public set finCoupe(value: string) {
		this._finCoupe = value;
	}

	public set tritu(value: boolean) {
		this._tritu = value;
	}

	public set paye(value: string) {
		this._paye = value;
	}

	public get livraisons(): Livraison[] {
		return this._livraisons;
	}

	public set delta(value: number) {
		this._delta = value;
	}

	///////////////
	// Serialize //
	///////////////

	public toJSON(): any {
		return {
			id       : this._id,
			boisType : this._boisType ? this._boisType.id : null,
			longueursAchat : this._longueursAchat ? this._longueursAchat.id : null,
			volumeAchat : this._volumeAchat,
			unite : this._unite,
			volumeRestant : this._volumeRestant,
			prixStere : this._prixStere,
			prixVente : this._prixVente,
			achat  : this._achat ? this._achat.id : null,
			finCoupe   : this._finCoupe,
			paye   : this._paye,
			delta   : this._delta,
			tritu   : this._tritu,
		};
	}

	public fromJSON(data: any): this {
		this._id        = data.id;
		this._boisType  = data.boisType ? (new BoisType()).fromJSON(data.boisType) : null;
		this._longueursAchat  = data.longueursAchat ? (new LongueursAchat()).fromJSON(data.longueursAchat) : null;
		this._volumeAchat  = data.volumeAchat;
		this._unite  = data.unite;
		this._volumeRestant  = data.volumeRestant;
		this._prixStere  = data.prixStere;
		this._prixVente  = data.prixVente;
		this._achat   = data.achat ? (new Achat()).fromJSON(data.achat) : null;
		this._finCoupe    = data.finCoupe;
		this._paye    = data.paye;
		this._livraisons = data.livraisons ? data.livraisons.map(c => (new Livraison()).fromJSON(c)) : null;
		if (this._livraisons) {
			for (const livraison of this._livraisons) {
				livraison.essenceAchat = this;
			}
		}
		this._createdAt   = data.createdAt ? new Date(data.createdAt) : null;
		this._delta    = data.delta;
		this._tritu    = data.tritu;
		return this;
	}
}
